import {
  EngineeringPlugin,
} from './EngineeringPlugin'

import type {
  GenesisExtensionManifest,
} from '../../platform/extensions/types'

export const manifest:
GenesisExtensionManifest = {
  id: 'engineering',
  name: 'Ingeniería',

  description:
    'Target, Proposal, Simulation, Validation, Authorization y Execution.',

  version: '1.0.0',
  apiVersion: '1',

  kind: 'MODULE',
  placement: 'LEFT',

  priority: 10,

  enabledByDefault: true,
  removable: true,

  requiredCapabilities: [
    'engineering.session.read',
  ],

  component:
    EngineeringPlugin,
}
